import CruiseDetailsContainer from './CruiseDetailsContainer';
import { withUserAndBaseData } from '../../lib';

export default withUserAndBaseData(CruiseDetailsContainer);
